export enum StationLevel {
    STATION_GROUP = 'STATION_GROUP', STATION_SET = 'STATION_SET', STATION = 'STATION'
}